// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"src-pages-business-components-BusinessProtocol-AuthProtocol-RZProtocolContent-__index__paragraph--1ILuy"};